const updateAdvSearchFilters = (state, payload) => {
    state.advSearchFilters = payload;
}

export default {
    updateAdvSearchFilters
}